import noop from 'mn-utils/noop';
import delay from 'mn-utils/delay';
import isEqual from 'mn-utils/isEqual';


module.exports = (setState, apiMethod, onFinally) => {
  let _lastParams;
  let _cancel = noop;

  function update() {
    _cancel();
    _cancel = delay(() => {
      const promise = apiMethod(_lastParams);
      if (!promise) {
        return;
      }
      setState({
        loading: true,
      });
      _cancel = promise.finally(onFinally || ((error, data) => {
        setState({
          loading: false,
          data: data || {},
        });
      })).cancel;
    });
  }
  function check(params) {
    if (!isEqual(_lastParams, params, 10)) {
      _lastParams = params;
      update();
    }
  }
  check.update = update;
  return check;
};
